import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { usePatchTemplate } from "../../../hook/templates";
import { TemplateNavigationPath } from "../../../models/templates";
import { queryClient } from "../../../utils/http/queryClient";
import { fetchTemplate } from "../../../utils/http/templates";
import EditorBlock from "./Editor";

interface NewTemplateData {
  id: string | null;
  inSync: boolean;
  body: string;
}

function Content({
  path,
  version,
  readOnly = true,
}: {
  path: TemplateNavigationPath;
  version: string;
  readOnly: boolean;
}) {
  const [bodyContent, setBodyContent] = useState<string>("");
  const [timeoutSaveDraftId, setTimeoutSaveDraftId] = useState<ReturnType<typeof setTimeout> | null>(null);

  const [newTemplateContent, setNewTemplateContent] = useState<NewTemplateData | null>(null);

  const patchMutation = usePatchTemplate(path, version);

  const { data: template = null } = useQuery({
    queryKey: ["mailTemplates", path.namespace, path.name, version],
    queryFn: async ({ signal }) => {
      return await fetchTemplate({ signal, key: path, version: version });
    },
  });

  // const { mutate: copyToDraft } = useMutation({
  //   mutationFn: putTemplate,
  //   onSuccess: async (data) => {
  //     console.log("Created new template:", data);
  //     queryClient.setQueryData(
  //       ["templateRender", selectedPath!.namespace, selectedPath!.name, "draft"],
  //       data
  //     );
  //     await queryClient.invalidateQueries({ queryKey: ["templatesSummary"] });
  //     navigate(`/templates/${selectedPath!.namespace}/${selectedPath!.category}/${selectedPath!.name}/draft`);
  //   },
  // });
  useEffect(() => {
    if (template) {
      const html = template?.content?.body ? template?.content?.body : ""; // .replace(/<br\/>\n/gi, "\n")

      setBodyContent(html);
      setNewTemplateContent({
        id: template.id,
        inSync: true,
        body: html,
      });
    }
  }, [template]);

  useEffect(() => {
    if (version !== "draft" || !newTemplateContent || newTemplateContent.inSync) return;

    try {
      if (timeoutSaveDraftId) {
        clearTimeout(timeoutSaveDraftId);
      }
      const timeoutId = setTimeout(async () => {
        // dataToSave.body = dataToSave.body.replace(/\n/gi, "<br/>\n").replace(/^$/gi, "<br/>\n");

        await patchMutation.mutateAsync({
          key: path,
          dataToUpdate: {
            content: {
              body: newTemplateContent.body,
            },
          },
        });
        setNewTemplateContent({ ...newTemplateContent, inSync: true });

        setTimeout(
          () =>
            queryClient.invalidateQueries({
              queryKey: ["templateRender", path.namespace, path.name],
            }),
          500
        );
      }, 1000);
      setTimeoutSaveDraftId(timeoutId);
    } catch (e) {
      console.log(e);
    }
  }, [newTemplateContent]);

  if (!newTemplateContent || !template) return <></>;

  const updateBodyContent = (body: string) => {
    if (body !== newTemplateContent?.body) {
      setNewTemplateContent({ ...newTemplateContent, inSync: false, body: body || "" });
    }
  };

  return (
    <div>
      {readOnly && (
        <div className="bg-danger text-white p-2 text-center">
          <b>currently read only mode</b>
        </div>
      )}
      <EditorBlock content={bodyContent} setContent={updateBodyContent} readOnly={readOnly} />
    </div>
  );
}

export default Content;
